module.exports = new __parcel__URL__("99889_h.81ae3214.jpg").toString();